export default __webpack_public_path__ + "static/media/bank_mandiri.10886996.svg";